import(/* webpackMode: "eager", webpackExports: ["VaultClient"] */ "/codebuild/output/src3094709904/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/vaults/[id]/VaultClient.tsx");
